import {
    listingDataReducer
} from "../reducers/listingDataSlice";


export const addListingData = (obj) => async (dispatch) => {
    dispatch(listingDataReducer.actions.addListingData(obj));
};

export const addListingImgsData = (obj) => async (dispatch) => {
    dispatch(listingDataReducer.actions.addListingImgsData(obj));
};